import { render } from "./Pagination4.vue?vue&type=template&id=316c0f1c"
import script from "./Pagination4.vue?vue&type=script&lang=js"
export * from "./Pagination4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__